import * as Sentry from '@sentry/vue';

class SentryStore {
    init = (app) => {
        if (this.isNotSetup) return;

        Sentry.init({
            app: app,
            trackComponents: true,
            // Do not attach component props to error events: contact and conversation objects carry customer personal data.
            attachProps: false,
            dsn: process.env.SENTRY_DSN,
            release: process.env.SENTRY_RELEASE,
            environment: this.environment,
            tracePropagationTargets: ['int/v5/core'],

            ...this.optionsSampleRate,

            integrations: [
                // Mask typed inputs and do not capture request/response bodies (SWR-24403): they carry tokens and credentials.
                Sentry.replayIntegration({
                    maskAllText: false,
                    maskAllInputs: true,
                    blockAllMedia: false,

                    networkRequestHeaders: ['Cache-Control'],
                    networkResponseHeaders: ['Referrer-Policy'],
                }),
                Sentry.replayCanvasIntegration(),
                Sentry.browserTracingIntegration(),
                Sentry.browserProfilingIntegration(),
            ],
        });

        this.startReplaySession();

        Sentry.setTag('app.name', 'vue');
    };

    get optionsSampleRate() {
        return {
            replaysSessionSampleRate: Number(process.env.SENTRY_REPLAYS_SESSION_SAMPLE_RATE) || 1.0,
            replaysOnErrorSampleRate:
                Number(process.env.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE) || 1.0,
            tracesSampleRate: Number(process.env.SENTRY_TRACES_SAMPLE_RATE) || 0.1,
            profilesSampleRate: Number(process.env.SENTRY_PROFILES_SAMPLE_RATE) || 0.1,
        };
    }

    get isNotSetup() {
        let hipaa = false;
        const token = sessionStorage.getItem('assume_token') || localStorage.getItem('token');

        if (token) {
            try {
                const [, tokenData] = token.split('.');
                const parsedData = JSON.parse(atob(tokenData));

                hipaa = parsedData.hipaa;
            } catch (e) {
                console.log(e);
            }
        }

        if (hipaa) {
            window.userpilot?.destroy?.();
            Sentry.getReplay()?.stop();

            return true;
        }
        return !process.env.SENTRY_DSN && !process.env.APP_ENV;
    }

    get environment() {
        return process.env.APP_ENV;
    }

    startReplaySession = () => {
        Sentry.getReplay()?.start();
    };

    stopReplaySession = () => {
        Sentry.getReplay()?.stop();
    };

    setUser = (user) => {
        if (this.isNotSetup) return;

        Sentry.setUser(user);
        Sentry.setContext('character', {
            ...user,
        });
    };

    setOrganization = (organization) => {
        if (this.isNotSetup) return;

        Sentry.setTag('organization.id', organization.id ?? 'null');
        Sentry.setTag('agency.id', organization.agency_id ?? 'null');
    };
}

const sentryStore = new SentryStore();

export const initSentry = sentryStore.init;
export const setUserSentry = sentryStore.setUser;
export const setOrganizationSentry = sentryStore.setOrganization;
